import React,{useState,useEffect} from 'react'
import { Popover } from 'react-tiny-popover'   
import { DateRangePicker } from 'react-date-range'
import { SelectionGroup,SelectionItem } from '../../Components/Selection/Selection'
import { PurpleButton } from '../../Components/Buttons/PurpleButton'
import { NumberSpin } from '../../Components/Spin/NumberSpin'
import {SearchNormalIcon,PinIcon} from "../../AssetComponents/Images"
import { useDispatch,useSelector } from 'react-redux'
import {setWho,setReservationPeriod} from "../../ReduxSlices/ReservationSlice"
import { useOnboarding } from './OnBoarding1';
import { getMinBookingDate } from '../../Components/utils/DateValidation';

export const RentalSearch1 = ({onSearch,setPinLocation})=>{
  const [desktopSearchPop, setDesktopSearchPop] = useState(false);
  const [mobileSearchPop, setMobileSearchPop] = useState(false);
  const [searchItem, setSearchItem] = useState(-1);
  const [predictList, setPredictList] = useState([]);
  const [addressInput, setAddressInput] = useState("");
  const [period, setPeriod] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
      color: "#5b1deeaa",
    },
  ]);
  const dispatch = useDispatch();
  const reservation_period = useSelector((state) => state.reservation.period);
  const who = useSelector((state) => state.reservation.who);
  const guests = useSelector((state) => state.reservation.guests);
  const { isOnboarding, currentStep } = useOnboarding();

  // Add highlighting during onboarding step 4 (search step)
  const isHighlighted = isOnboarding && currentStep === 4;

  const getAddressList = async (input) => {
    // No logic - UI only
  };

  const handleSelectFromAddressList = async (place_id, description) => {
    // No logic - UI only
  };
  
  useEffect(() => {
    // No logic - UI only
  }, [addressInput]);

  useEffect(() => {
    // No logic - UI only
  }, [period]);

const handleSearch = async () => {
  // No logic - UI only
};

  const handleDesktopItemClick = (item) => {
    setSearchItem(item);
    setDesktopSearchPop(true);
  };

  const handleCloseMobileModal = () => {
    setMobileSearchPop(false);
    setSearchItem(-1);
    setPredictList([]);
  };

  const handleMobileClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setMobileSearchPop(true);
  };

  // Prevent body scroll when mobile modal is open
  useEffect(() => {
    if (mobileSearchPop) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [mobileSearchPop]);

  return (
    <>
      {/* Desktop Search Bar */}
      <div className="hidden lg:block">
        <Popover
          isOpen={desktopSearchPop}
          positions={["bottom"]}
          onClickOutside={() => {
            setDesktopSearchPop(false);
            setSearchItem(-1);
            setPredictList([]);
          }}
                     containerStyle={{ zIndex: 9999999 }}
          content={
                         <div className="mt-[10px] z-[9999999] bg-white rounded-[10px] w-max h-max shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
              {searchItem === 0 && predictList?.map((address) => (
                <div
                  key={address.place_id}
                  onClick={() => {}}
                  className="w-[400px] bg-white flex gap-[10px] items-center cursor-pointer overflow-hidden h-[50px] p-[8px] rounded-[8px] hover:bg-gray-300"
                >
                  <PinIcon />
                  <div className="w-full truncate">{address.description}</div>
                </div>
              ))}
              {(searchItem === 1 || searchItem === 2) && (
                <DateRangePicker
                  onChange={() => {}}
                  months={2}
                  ranges={period}
                  direction="horizontal"
                  minDate={getMinBookingDate()}
                  color="#5b1dee"
                  startDatePlaceholder="Check In"
                  endDatePlaceholder="Check Out"
                  className="my-[20px]"
                  showDateDisplay={false}
                />
              )}
              {searchItem === 3 && (
                <div className="w-[340px] p-[20px] space-y-[10px]">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-semibold">Adults</div>
                      <div className="text-[#959595]">Age 13 or above</div>
                    </div>
                    <NumberSpin
                      value={who.adults || 1}
                      onChange={() => {}}
                      min={1}
                    />
                  </div>
                         <div className="flex items-center justify-between ">
                          <div>
                            <div className="font-semibold">Children</div>
                            <div className="text-[#959595]">Age 2-12</div>
                          </div>
                          <div className="flex items-center">
                            <NumberSpin
                              value={who.children || 0}
                              onChange={() => {}}
                              min={0}
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-between ">
                          <div>
                            <div className="font-semibold">Infants</div>
                            <div className="text-[#959595]">Under 2</div>
                          </div>
                          <div className="flex items-center">
                            <NumberSpin
                              value={who.infants || 0}
                              onChange={() => {}}
                              min={0}
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-between ">
                          <div>
                            <div className="font-semibold">Pets</div>
                            <div className="text-[#959595]">Pet friendly only</div>
                          </div>
                          <div className="flex items-center">
                            <NumberSpin
                              value={who.pets || 0}
                              onChange={() => {}}
                              min={0}
                            />
                        </div>
                        </div>
                    </div>
              )}
            </div>
          }
        >
          <div className={`flex items-center h-max w-max bg-white border-[2px] gap-[1px] border-[#e3e3e3] rounded-[14px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
            isHighlighted ? 'onboarding-highlight border-2 border-purple-500 ring-4 ring-purple-300 animate-pulse' : ''
          }`}>
            <div onClick={() => {}}>
              <SelectionGroup
                SelectedItemMask="rounded-[10px] bg-[#e3e3e3]"
                defaultItem={searchItem}
                className="gap-[2px] flex items-center w-max rounded-[14px]"
              >
                <SelectionItem
                  UnselectedItem={
                    <div
                      onClick={() => {}}
                      className="cursor-pointer hover:bg-[#f6f6f6] space-y-[4px] py-[8px] px-[20px] bg-white rounded-[10px]"
                    >
                      <div className="text-[16px]">Where</div>
                      <input
                        placeholder="Search destinations"
                        className="outline-none font-normal truncate"
                        value={addressInput}
                        onChange={() => {}}
                      />
                    </div>
                  }
                  SelectedItem={
                    <div className="cursor-pointer hover:bg-[#f6f6f6] space-y-[4px] py-[8px] px-[20px] bg-[#e3e3e3] rounded-[10px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.8),0px_1px_2px_0px_rgba(0,0,0,0.1)]">
                      <div className="text-[16px]">Where</div>
                      <input
                        placeholder="Search destinations"
                        className="outline-none bg-[#e3e3e3] font-normal truncate"
                        value={addressInput}
                        onChange={() => {}}
                      />
                    </div>
                  }
                />
                 <SelectionItem
                        UnselectedItem={
                          <div
                            onClick={() => {}}
                            className="space-y-[4px] hover:bg-[#f6f6f6] py-[8px] px-[20px] bg-white rounded-[10px]"
                          >
                            <div className="">Check in</div>
                            <div className="text-[#666666] font-normal truncate">
                              {reservation_period.start
                                ? new Date(
                                    reservation_period.start * 1000
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })
                                : "Add Date"}
                            </div>
                          </div>
                        }
                        SelectedItem={
                          <div className="space-y-[4px] hover:bg-[#f6f6f6] py-[8px] px-[20px] bg-[#e3e3e3] rounded-[10px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.8),0px_1px_2px_0px_rgba(0,0,0,0.1)]">
                            <div className="">Check in</div>
                            <div className="text-[#666666] font-normal truncate">
                              {reservation_period.start
                                ? new Date(
                                    reservation_period.start * 1000
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })
                                : "Add Date"}
                            </div>
                          </div>
                        }
                      />
                      <SelectionItem
                        UnselectedItem={
                          <div
                            onClick={() => {}}
                            className="space-y-[4px] hover:bg-[#f6f6f6] py-[8px] px-[20px] bg-white w-[120px] rounded-[10px]"
                          >
                            <div className="">Check out</div>
                            <div className="text-[#666666] font-normal truncate">
                              {reservation_period.end
                                ? new Date(
                                    reservation_period.end * 1000
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })
                                : "Add Date"}
                            </div>
                          </div>
                        }
                        SelectedItem={
                          <div className="space-y-[4px] hover:bg-[#f6f6f6] py-[8px] px-[20px] bg-[#e3e3e3] rounded-[10px] w-[120px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.8),0px_1px_2px_0px_rgba(0,0,0,0.1)]">
                            <div className="">Check out</div>
                            <div className="text-[#666666] font-normal truncate">
                              {reservation_period.end
                                ? new Date(
                                    reservation_period.end * 1000
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })
                                : "Add Date"}
                            </div>
                          </div>
                        }
                      />
                      <SelectionItem
                        UnselectedItem={
                          <div
                            onClick={() => {}}
                            className="space-y-[4px] hover:bg-[#f6f6f6] py-[8px] px-[20px] bg-white w-[120px] rounded-[10px]"
                          >
                            <div className="">Who</div>
                            <div className="text-[#666666] font-normal tr uncate">
                              {guests ? guests : "Add Guests"}
                            </div>
                          </div>
                        }
                        SelectedItem={
                          <div className="space-y-[4px] hover:bg-[#f6f6f6] py-[8px] px-[20px] bg-[#e3e3e3] rounded-[10px] w-[120px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.8),0px_1px_2px_0px_rgba(0,0,0,0.1)]">
                            <div className="">Who</div>
                            <div className="text-[#666666] font-normal truncate">
                              {guests ? guests : "Add Guests"}
                            </div>
                          </div>
                        }
                      />
            </SelectionGroup>
          </div>
          <div className="px-[10px]">
            <PurpleButton
              text={
                <div className="flex items-center gap-[10px]">
                  <SearchNormalIcon />
                  <div className="font-normal">Search</div>
                </div>
              }
              onClick={() => {}}
            />
          </div>
        </div>
      </Popover>
      </div>

      {/* Mobile Search Bar - Copy structure from Search.js */}
      <div className="lg:hidden w-full">
        <div
          onClick={handleMobileClick}
          className={`w-full bg-white rounded-full shadow-md border p-4 cursor-pointer touch-manipulation active:bg-gray-50 ${
            isHighlighted 
              ? 'border-4 border-purple-500 ring-4 ring-purple-300' 
              : 'border border-gray-200'
          }`}
          style={{ 
            userSelect: 'none',
            touchAction: 'manipulation'
          }}
        >
          <div className="flex items-center gap-3">
            <SearchNormalIcon />
            <div className="flex-1">
              <div className="text-sm font-medium text-gray-900">
                {addressInput || "Where to?"}
              </div>
              <div className="text-xs text-gray-500">
                {reservation_period.start && reservation_period.end
                  ? `${new Date(reservation_period.start * 1000).toLocaleDateString("en-US", { month: "short", day: "numeric" })} - ${new Date(reservation_period.end * 1000).toLocaleDateString("en-US", { month: "short", day: "numeric" })}`
                  : "Any week"} • {guests || "Add guests"}
              </div>
            </div>
            <div className="w-8 h-8 bg-[#5b1dee] rounded-full flex items-center justify-center">
              <SearchNormalIcon className="w-4 h-4 text-white" />
            </div>
          </div>
        </div>

        {/* Mobile Search Modal - Copy from Search.js */}
        {mobileSearchPop && (
          <div 
            className="fixed inset-0 bg-white overflow-y-auto lg:hidden"
            style={{ 
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999999,
              backgroundColor: 'white'
            }}
          >
            <div className="min-h-full flex flex-col">
              {/* Header with close button */}
              <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white sticky top-0">
                <button
                  onClick={handleCloseMobileModal}
                  className="p-2 rounded-full hover:bg-gray-100 touch-manipulation bg-gray-100"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                <h2 className="text-lg font-semibold">Search</h2>
                <div className="w-10"></div>
              </div>

              {/* Content */}
              <div className="flex-1 p-4 pb-24">
                {/* Where Section */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold mb-4">Where</h3>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search destinations"
                      className="w-full p-4 border border-gray-300 rounded-lg text-lg focus:outline-none focus:border-purple-500"
                      value={addressInput}
                      onChange={(e) => setAddressInput(e.target.value)}
                      autoFocus
                    />
                  </div>
                </div>

                {/* When Section */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold mb-4">When</h3>
                  <div className="grid grid-cols-2 gap-3 mb-4">
                    <button
                      onClick={() => setSearchItem(1)}
                      className={`p-4 border rounded-lg text-left touch-manipulation ${
                        searchItem === 1 ? 'border-purple-500 bg-purple-50' : 'border-gray-300'
                      }`}
                    >
                      <div className="text-xs text-gray-500 mb-1">CHECK-IN</div>
                      <div className="font-medium">
                        {reservation_period.start
                          ? new Date(reservation_period.start * 1000).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                            })
                          : "Add date"}
                      </div>
                    </button>
                    <button
                      onClick={() => setSearchItem(2)}
                      className={`p-4 border rounded-lg text-left touch-manipulation ${
                        searchItem === 2 ? 'border-purple-500 bg-purple-50' : 'border-gray-300'
                      }`}
                    >
                      <div className="text-xs text-gray-500 mb-1">CHECK-OUT</div>
                      <div className="font-medium">
                        {reservation_period.end
                          ? new Date(reservation_period.end * 1000).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                            })
                          : "Add date"}
                      </div>
                    </button>
                  </div>
                </div>

                {/* Who Section */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold mb-4">Who</h3>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between py-3">
                      <div>
                        <div className="font-medium">Adults</div>
                        <div className="text-sm text-gray-500">Age 13 or above</div>
                      </div>
                      <NumberSpin
                        value={who.adults || 1}
                        onChange={() => {}}
                        min={1}
                      />
                    </div>
                    <div className="flex items-center justify-between py-3">
                      <div>
                        <div className="font-medium">Children</div>
                        <div className="text-sm text-gray-500">Age 2-12</div>
                      </div>
                      <NumberSpin
                        value={who.children || 0}
                        onChange={() => {}}
                        min={0}
                      />
                    </div>
                    <div className="flex items-center justify-between py-3">
                      <div>
                        <div className="font-medium">Infants</div>
                        <div className="text-sm text-gray-500">Under 2</div>
                      </div>
                      <NumberSpin
                        value={who.infants || 0}
                        onChange={() => {}}
                        min={0}
                      />
                    </div>
                    <div className="flex items-center justify-between py-3">
                      <div>
                        <div className="font-medium">Pets</div>
                        <div className="text-sm text-gray-500">Pet friendly only</div>
                      </div>
                      <NumberSpin
                        value={who.pets || 0}
                        onChange={() => {}}
                        min={0}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Fixed Search Button */}
              <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200">
                <button
                  onClick={() => {
                    handleCloseMobileModal();
                  }}
                  className="w-full bg-purple-600 text-white py-4 px-6 rounded-lg font-semibold text-lg hover:bg-purple-700 active:bg-purple-700 touch-manipulation flex items-center justify-center gap-2"
                  style={{ backgroundColor: '#5b1dee' }}
                >
                  <SearchNormalIcon className="w-5 h-5" />
                  <span>Search</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};